import { render } from "./vphotoidadd.vue?vue&type=template&id=58b9937c&scoped=true"
import script from "./vphotoidadd.vue?vue&type=script&lang=js"
export * from "./vphotoidadd.vue?vue&type=script&lang=js"

import "./vphotoidadd.vue?vue&type=style&index=0&id=58b9937c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b9937c"]])

export default __exports__